import React from 'react';
import SessionStore from 'stores/SessionStore';
import UserActionCreators from 'actions/UserActionCreators';
const Login = () => {
    return (React.createElement("div", { className: "absolute p-6 top-0 right-0" },
        React.createElement("a", { href: "/login", className: "text-white" }, "Login")));
};
const Logout = () => {
    return (React.createElement("div", { className: "absolute p-6 top-0 right-0" },
        React.createElement("a", { href: "#", onClick: () => UserActionCreators.logout(), className: "text-white" }, "Logout")));
};
const TrackingHeader = (props) => {
    if (!SessionStore.isQuotesOnly() && SessionStore.isLoggedIn())
        return null;
    return (React.createElement("div", { className: "flex bg-blue-darker" },
        React.createElement("div", { className: "flex justify-center w-full" },
            React.createElement("a", { href: "https://www.cargomatic.com", target: "_new" },
                React.createElement("img", { width: "200", src: "https://cargomatic.com/wp-content/uploads/2020/07/Cargomatic-Logo-Hi-Res-White.png", alt: "Cargomatic" })),
            !SessionStore.isLoggedIn() && React.createElement(Login, null),
            SessionStore.isLoggedIn() && React.createElement(Logout, null))));
};
module.exports = TrackingHeader;
